// extracted by mini-css-extract-plugin
export default {"currency":"string_utils_currency__zLcW2"};